var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-block",class:{ selected: _vm.selected }},[_c('v-text-field',{style:(_vm.headingStyle),attrs:{"value":_vm.block.text,"placeholder":"Überschrift…","dense":"","hide-details":"","flat":"","solo":"","background-color":"transparent"},on:{"input":_vm.onTextChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }